import baseFilterMutations from '../base_filter_mutations';

export default {
    ...baseFilterMutations,

    updateMeta(state, payload) {
        Object.assign(state.meta, payload.meta);
    },

    updateFilters(state, payload) {
        state.params = Object.assign({}, state.params, payload);
    },

    updateSearch(state, payload) {
        state.params.search = payload;
    },

    updateOrder(state, payload) {
        state.params.sort = payload;
    },

    updatePage(state, payload) {
        state.params.page = payload;
    },

    updateDropdownToAddBestMatch(state, payload) {
        if (payload.addBestMatch) {
            const rankOptionIndex = state.sortOptions.findIndex(option => option.key === 'rank');

            if (rankOptionIndex === -1) {
                state.sortOptions.unshift({
                    key: 'rank',
                    label: 'Best Match'
                });
            }
            state.params.sort = 'rank';
        } else {
            const rankOptionIndex = state.sortOptions.findIndex(option => option.key === 'rank');

            if (rankOptionIndex !== -1) {
                state.sortOptions.splice(rankOptionIndex, 1);
            }
            state.params.sort = 'newest';
        }
    }
}
